import { TextInput as GrommetTextInput, TextInputProps as GrommetTextInputProps, Text } from 'grommet'
import { ChangeEvent } from 'react'

interface IInputProps extends GrommetTextInputProps {
  placeholder?: string
  value?: string
  label?: string
  style?: React.CSSProperties
  handleChange?: (x: ChangeEvent<HTMLInputElement>) => void
  className?: string
}

export const Input = ({ placeholder = 'type here', value, handleChange, label, className, ...props }: IInputProps) => (
  <>
    {label ? (
      <Text margin={{ bottom: '2px' }} style={{ fontSize: '14px', fontWeight: 500 }}>
        {label}
      </Text>
    ) : null}
    <GrommetTextInput
      onChange={handleChange && handleChange}
      placeholder={placeholder}
      value={value}
      {...props}
      className={className}
      style={{ borderRadius: '100px', ...props.style }}
    />
  </>
)

export * from './TextSearch'
